import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CarityTheme, Main, Statusbar } from './main';
import { QueryParamsContextProvider } from './shared';
import './translations/i18n';
import { setDefaultOptions } from 'date-fns';
import { nlBE } from 'date-fns/locale';

const queryClient = new QueryClient({
    defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

export function App() {
    setDefaultOptions({ locale: nlBE });

    return (
        <CarityTheme>
            <QueryParamsContextProvider>
                <QueryClientProvider client={queryClient}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Main />
                        <Statusbar />
                    </LocalizationProvider>
                </QueryClientProvider>
            </QueryParamsContextProvider>
        </CarityTheme>
    );
}
